import React, { useState, useEffect } from "react";
import s from "./menu-button.module.scss";

const MenuButton = (props) => {

    const [icon, setIcon] = useState(props.icon);
    const [title, setTitle] = useState(props.title);
    const [type, setType] = useState(props.type);
    const [iSelected, setIsSelected] = useState(props.selected);
    const [isReadOnly, setIsReadOnly] = useState(props.isReadOnly)

    useEffect(() => {
        setIsSelected(props.selected);
        setIsReadOnly(props.isReadOnly);
        setTitle(props.title)
    }, [props])

    const handleClickMenuButton = (type) => {
        if(props.callback) props.callback(type);
    }

    return (
        <button disabled={isReadOnly} className={iSelected ? s.active + " " + s.MenuButton : s.MenuButton} onClick={handleClickMenuButton.bind(this, type)}>
            <span>{title}</span>
            {icon}
        </button>
    )
}

export default MenuButton;